var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container clearfix"},[_c('div',{staticClass:"logo"},[_c('logo')],1),_c('div',{staticClass:"user"},[_c('user')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }